import { createContext, useContext } from 'react';

import { LanguageKeys } from 'src/common/constants/languages';
import { IPageDocument } from 'src/helpers/pageDocumentUtils';
import { IPageBlock } from 'src/interfaces/PageBlock';

interface PublicPageEditContextValue {
  contentKey: string;
  pageContentId?: string;
  document: IPageDocument;
  heroBlocks: IPageBlock[];
  bodyBlocks: IPageBlock[];
  isEditMode: boolean;
  selectedEditorLang: LanguageKeys;
  updateTextBlock: (blockId: string, html: string) => void;
}

const PublicPageEditContext = createContext<PublicPageEditContextValue | null>(null);

export function usePublicPageEdit(): PublicPageEditContextValue | null {
  return useContext(PublicPageEditContext);
}

export default PublicPageEditContext;
